import React from 'react';
import { useLocation } from "react-router-dom";
import Profile from '../Profile/Profile';

export default function ProfileRouter( props )
{
  let location = useLocation();

  // Check if the profile URL location.pathname is a username profile query in the format: "/profile/<username>", or if it is a userID query in the format: "/profile/u/<userID>"

  let profileQueryData = location.pathname.substring( 9 );
  let isUserIdFormat = profileQueryData.startsWith( 'u/' );

  if( isUserIdFormat )
  {
    return (
      <Profile profileUserId={ profileQueryData.substring( 2 ) } />
    );
  }

  if( location.hash )
  {
    profileQueryData += location.hash;
  }

  return (
    <Profile profileName={ profileQueryData } />
  );
}
